import React from 'react';
import {map, uniqueId} from 'lodash';
import IconCardButton from './icon-card-button';
import styles from './icons.module.scss';
import iconManifest from 'fonts/icon-manifest.json';

const Library = () => (
  <>
    <h2>Library</h2>
    <div className={styles.library}>
      {map(iconManifest, (icon) => (
        <IconCardButton key={uniqueId(`${icon}-`)} name={icon} />
      ))}
    </div>
  </>
);

export default Library;
